import { startCase } from 'lodash';

export function formatPageCellLabel(value) {
  if (!value) {
    return '';
  }

  return startCase(value);
}
